import { Alert, AlertKind, DescriptionList } from "@prequel/shared-components";

import Timestamp from "@/components/Timestamp";
import { useLoadContext } from "@/pages/import/StreamsPage/LoadPage";

const formatCount = (value: number | null | undefined) => value?.toLocaleString() ?? "-";

const LoadDetails = () => {
  const { load } = useLoadContext();
  const hasErrored = (load.records_errored ?? 0) > 0;
  const recordIDs = load.record_ids?.length ? load.record_ids.join("\n") : "None";

  return (
    <div className="space-y-8">
      {load.error && <Alert kind={AlertKind.ERROR}>{load.error.message}</Alert>}

      <div>
        <h3 className="text-lg/6 font-medium text-gray-900">Details</h3>
        <div className="mt-4">
          <DescriptionList>
            <DescriptionList.Item label="ID" value={load.id} />
            <DescriptionList.Item label="Stream ID" value={load.stream_id} />
            <DescriptionList.Item label="Actor ID" value={load.actor_id} />
            <DescriptionList.Item label="Actor Type" value={load.actor_type} />
            <DescriptionList.Item label="Submitted" value={<Timestamp timestamp={load.submitted_at} />} />
            <DescriptionList.Item
              label="Started"
              value={load.started_at ? <Timestamp timestamp={load.started_at} /> : "-"}
            />
            <DescriptionList.Item label="Ended" value={load.ended_at ? <Timestamp timestamp={load.ended_at} /> : "-"} />
          </DescriptionList>
        </div>
      </div>

      <div>
        <h3 className="text-lg/6 font-medium text-gray-900">Summary</h3>
        <div className="mt-4">
          <DescriptionList>
            <DescriptionList.Item label="Processed" value={formatCount(load.records_processed)} />
            <DescriptionList.Item label="Transformed" value={formatCount(load.records_transformed)} />
            <DescriptionList.Item label="Valid" value={formatCount(load.records_valid)} />
            <DescriptionList.Item label="Loaded" value={formatCount(load.records_loaded)} />
            <DescriptionList.Item
              label="Errored"
              value={
                <span className={hasErrored ? "text-red-600" : undefined}>{formatCount(load.records_errored)}</span>
              }
            />
            <DescriptionList.CodeBlockItem label="Record IDs" value={recordIDs} />
          </DescriptionList>
        </div>
      </div>
    </div>
  );
};

export default LoadDetails;
